import { render, staticRenderFns } from "./tempImageBedModal.vue?vue&type=template&id=73f39d24&scoped=true&"
import script from "./tempImageBedModal.vue?vue&type=script&lang=js&"
export * from "./tempImageBedModal.vue?vue&type=script&lang=js&"
import style0 from "./tempImageBedModal.vue?vue&type=style&index=0&id=73f39d24&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f39d24",
  null
  
)

export default component.exports